import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "../data";
import { WhatsAppButton } from "./WhatsAppButton";
import { ShieldCheck } from "lucide-react";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "border-b border-white/10 bg-[#070A11]/85 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <img src={LOGO_URL} alt="TSU-Partners" className="h-9 w-9 rounded-lg object-cover ring-1 ring-white/15" />
          <span className="font-heading text-base font-extrabold text-white sm:text-lg">
            TSU<span className="gradient-text">-PARTNERS</span>
          </span>
        </Link>

        <div className="hidden items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-semibold text-gray-300 md:flex">
          <ShieldCheck className="h-3.5 w-3.5 text-[#60A5FA]" /> Seriöse Überführungen · DE · AT · CH
        </div>

        <WhatsAppButton size="sm" testid="nav-whatsapp" label="WhatsApp" />
      </div>
    </header>
  );
};
